/**
 *  map.serv.js
 */

class mapHelperServ {

    constructor($q, $compile, mapServ) {

        this.$q = $q;
        this.$compile = $compile;
    
        this.mapServ = mapServ;

        this.markerOptions = this.mapServ.readMarkerOptions();
    }

    _getMarkerIconByShopType(shopType) {
        var size;
        if (shopType === 'smartStore') {
            size = new google.maps.Size(this.markerOptions.bigSize, this.markerOptions.bigSize);
        } else {
            size = new google.maps.Size(this.markerOptions.smallSize, this.markerOptions.smallSize);
        }
        return new google.maps.MarkerImage(this.markerOptions.icon[shopType], null, null, null, size);
    }

    _getMarkerZIndexByShopType(shopType) {
        return this.markerOptions.zIndex[shopType];
    }

    _getTodaysProgram(program1, program2, program3, sscheduleExceptions) {
        var date = new Date(),
            today = date.getDay(),
            program;

        var sunday = program3 !== null ? program3.substr(program3.indexOf('D') + 3, program3.length - 1) : "",
            monday = program1 !== null ? program1.substr(2, program1.indexOf('M') - 2) : "",
            tuesday = program1 !== null ? program1.substr(program1.indexOf('M') + 2, program1.indexOf('M') - 2) : "",
            wednesday = program1 !== null ? program1.substr(program1.indexOf('Mi') + 3, program1.length - 1) : "",
            thursday = program2 !== null ? program2.substr(2, program2.indexOf('V') - 2) : "" ,
            friday = program2 !== null ? program2.substr(program2.indexOf('V') + 3, program2.length - 1) : "",
            saturday = program3 !== null ? program3.substr(2, program3.indexOf('D') - 2) : "";

        switch (today) {
            case 0:
                program = sunday;
                break;
            case 1:
                program = monday;
                break;
            case 2:
                program = tuesday;
                break;
            case 3:
                program = wednesday;
                break;
            case 4:
                program = thursday;
                break;
            case 5:
                program = friday;
                break;
            case 6:
                program = saturday;
                break;
        }

        return program;
    }

    _createMarker(latLng, icon, zIndex, customProperties) {
        return new google.maps.Marker({
            position: latLng,
            icon: icon,
            zIndex: zIndex,
            customProperties: customProperties
        });
    }

    _calcDistanceBetweenTwoPositions(positionOne, positionTwo) {
        return google.maps.geometry.spherical.computeDistanceBetween(positionOne, positionTwo);
    }

    _formatDistance(distance) {
        return distance < 1000 ? distance.toFixed(0) + ' m' : (distance / 1000).toFixed(2) + ' Km';
    }

    sortShopsClosestToPosition(shops, position) {
        return shops.sort((a, b) => {
            return this._calcDistanceBetweenTwoPositions(position, this.getLatLng(a.lat, a.lng)) - this._calcDistanceBetweenTwoPositions(position, this.getLatLng(b.lat, b.lng));
        });
    }

    getDistance(positionOne, positionTwo) {
        return this._formatDistance(
            this._calcDistanceBetweenTwoPositions(positionOne, positionTwo)
        );
    }

    getLatLng(lat, lng) {
        if (typeof lat !== 'number' || typeof lng !== 'number') {
            throw new Error('map-helper.serv.js > getLatLng > incorrect format for the lat and lng parameters');
        }
        return new google.maps.LatLng(lat, lng);
    }

    getDirectionUrl(startAddress, destinationAddress) {
        return startAddress ? ('https://maps.google.ro?saddr=' + startAddress + '&daddr=' + destinationAddress) : ('https://maps.google.ro?&daddr=' + destinationAddress);
    }

    getLiteralBounds(bounds) {
        let southWest = bounds.getSouthWest();
        let northEast = bounds.getNorthEast();
        return {
            southWestLat: southWest.lat(),
            southWestLng: southWest.lng(),
            northEastLat: northEast.lat(),
            northEastLng: northEast.lng()
        };
    }
}

mapHelperServ.$inject = ['$q', '$compile', 'mapServ'];

export default mapHelperServ;